var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e0d51e649a32c658d1d90865594be51d087a1dab"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["jobsinjs-main@webhouse-ltd"]={id:"e0d51e649a32c658d1d90865594be51d087a1dab"};
      